import { CaseState } from 'app/area/case/types-store';
import { getById } from 'app/infrastructure/store';
import { selectEntitiesOrEditingValues } from 'app/infrastructure/ui/renderer/resolvers';
import { ComponentDescriptor, ConnectedComponentProps } from 'app/infrastructure/ui/types-uischema';
import { CompositeKeys } from 'app/types-shared';
import { createSelector } from 'reselect';
import { getValue as defaultValueGetter } from 'app/infrastructure/ui/form/selectors';


export const childValues = (caseState: CaseState, uiEngineProps: ConnectedComponentProps) => {

  const selectEntityId = (_, props) => props.resolveContext?.path;
  const selectChildren = (_, props) => props.componentDescriptor?.children;
  const selectGetValue = (_, props) => props.valueSelector || defaultValueGetter;
  
  const selectEntityData = createSelector(
    [selectEntitiesOrEditingValues, selectEntityId, selectChildren, selectGetValue],
    (editing, entityId: CompositeKeys, children: ComponentDescriptor[], getValue) => {
      const entityData = getById(editing, entityId);
      return children?.length && children
        .filter(child => child.dataTag) // Only children that has a dataTag
        .map(child =>
          getValue(entityData, child.dataTag)
        );
    }
  );

  const entityDataValues = selectEntityData(caseState, uiEngineProps);

  return {
    childValues: entityDataValues
  };
};
